/**
 * SAN helpers for the outgoing move packet. PlayChess mutates a long-lived
 * `game` instance and reads `game.history().slice(-1)[0]` (index.js
 * L3619-3628); the store has no mutable board, so we build a throwaway
 * chess.js instance from the authoritative FEN instead — same SAN, no shared
 * mutable state between the board and the socket.
 *
 * chess.js 1.0.0-beta.8 THROWS on an illegal move (and on an invalid FEN), so
 * every call is wrapped.
 */
import {Chess} from 'chess.js';

/** @returns the SAN of the move, or null when it is illegal in `fen`. */
export function sanFor(
  fen: string,
  from: string,
  to: string,
  promotion?: string,
): string | null {
  try {
    const game = new Chess(fen);
    const move = game.move({from, to, promotion: promotion || undefined});
    return move ? move.san : null;
  } catch (e) {
    return null;
  }
}

/** Colour to move in `fen` ('w' | 'b'), or null when the FEN is unusable. */
export function turnOf(fen: string): 'w' | 'b' | null {
  const field = typeof fen === 'string' ? fen.split(' ')[1] : undefined;
  return field === 'w' || field === 'b' ? field : null;
}
